import $ from 'jquery';
import { convertStrToMilitaryTime } from '../utilities';
import { __ } from '@wordpress/i18n';

$('.js-time-chip').each(function () {
  const now = new Date();
  const currentTime = now.getHours() + now.getMinutes() / 60;
  const openStr = $(this).data('open');
  const closeStr = $(this).data('close');
  const open = convertStrToMilitaryTime(openStr.split('|')[0], openStr.split('|')[1]);
  const close = convertStrToMilitaryTime(closeStr.split('|')[0], closeStr.split('|')[1]);

  if (currentTime >= open && currentTime <= close) {

    $(this).addClass('active');
    $(this).find('.chip-text').text(__('Open Now', 'oem-theme'));
    
  } else {

    $(this).removeClass('active');
    $(this).find('.chip-text').text(__('Closed Now', 'oem-theme'));
  }
});
